export default "__VITE_ASSET__BpwEQkXb__"